var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"show":true,"centered":"","size":"fluid","title":"Comprobante"},on:{"hide":function($event){return _vm.$emit('hide', _vm.flags.reload)}}},[_c('Comprobante2',{attrs:{"initialModo":1,"initialCliente":{
      agencia: _vm.comprobante.idAgencia,
    },"initialComprobante":{
      moneda: _vm.comprobante.idMoneda,
    },"initialItems":_vm.comprobante.items},on:{"facturar":_vm.onFacturar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }